<template>
  <div class="search">
    <router-link to="/" class="logo-wrap"><img src="../../logo.svg" height="120" alt="logo" /></router-link>
    <div class="container">
      <i-input v-if="$route.path != '/goodsList'" v-model="searchData" size="large" class="sreach" placeholder="输入你想查找的商品">
        <Button slot="append" icon="ios-search" @click="search"></Button>
      </i-input>
      <!-- <Tag v-for="(item, index) in promotionTags" :key="index" closable  @on-close="closeTags(index)"><span @click="selectTags(index)">{{item}}</span></Tag> -->
    </div>
    <img src="/static/img/service.svg" width="200" height="80" alt="服务">
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      searchData: '',
      promotionTags: ['买2免1', '领200神券', '199减100', '母婴5折抢', '充100送20']
    };
  },
  methods: {
    closeTags (index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags (index) {
      this.searchData = this.promotionTags[index];
    },
    search () {
      this.$router.push({path: '/goodsList', query: { searchData: this.searchData }});
    }
  }
};
</script>

<style scoped>
.search {
  display: flex;
  align-items: center;
  width: 1000px;
  margin: 0 auto;
}
.logo-wrap {
  display: inline-block;
  width: 200px;
  vertical-align: top;
}
.container {
  display: inline-block;
  padding-top: 15px;
  margin: 0px auto;
  margin-bottom: 15px;
  width: 460px;
}
.sreach {
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue